'use es6';

export const MODULES_REMOVED_FROM_TREES = 'MODULES_REMOVED_FROM_TREES';
export const CELL_WIDTHS_CHANGED = 'CELL_WIDTHS_CHANGED';
export const TREE_STRUCTURE_CHANGED = 'TREE_STRUCTURE_CHANGED';
export const TREE_COUNT_CHANGED = 'TREE_COUNT_CHANGED';
export const USER_STYLE_CHANGED = 'USER_STYLE_CHANGED';